export const getRange = (start = 0, end = 0) => {
  let final = [];
  for (let i = start; i <= end; i++) {
    final.push(i);
  }
  return final;
}